import { render } from "./page10.vue?vue&type=template&id=50164d08&scoped=true"
import script from "./page10.vue?vue&type=script&lang=js"
export * from "./page10.vue?vue&type=script&lang=js"

import "./page10.vue?vue&type=style&index=0&id=50164d08&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/carbon-space-admin-site-CI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50164d08"]])

export default __exports__